<template>
  <N2Inicio v-if="plantilla.nombre === 'notaria2'" />
  <N3Inicio v-else-if="plantilla.nombre === 'notaria3'" />
  <N4Inicio v-else-if="plantilla.nombre === 'notaria4'" />
  <N5Inicio v-else-if="plantilla.nombre === 'notaria5'" />
  <div v-else id="home">
    <!-- Start Slider Area  -->
    <template v-if="NOTARIA && NOTARIA.Theme">
      <SliderBannerNotinModern v-if="NOTARIA.Theme.Home.Banner.Design === 1" />
      <SliderBannerNotinDynamic v-else-if="NOTARIA.Theme.Home.Banner.Design === 2" />
      <SliderBannerNotinOne v-else />
    </template>
    <!-- End Slider Area -->

    <!-- Start About Area -->
    <template v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.PN">
      <AboutPalabrasNotinTwo class="home-section" v-if="NOTARIA.Theme.Home.PN.Design === 1" />
      <AboutPalabrasNotinOne class="home-section" v-else />
    </template>
    <AboutPalabrasNotinOne v-else class="home-section" />
    <!-- End About Area -->

    <!-- Start Service Area -->
    <template v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.Servicios">
      <ServiceNotinTwo class="home-section" v-if="NOTARIA.Theme.Home.Servicios.Design === 1" />
      <ServiceNotinOne v-else class="home-section" />
    </template>
    <ServiceNotinOne v-else class="home-section" />
    <!-- End Service Area -->

    <!-- Start Counterup Area -->
    <!-- <div class="rn-counterup-area pt--25 pb--110 bg_color--1">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="section-title text-center">
                <h3 class="fontWeight500">Our Fun Facts</h3>
              </div>
            </v-col>
          </v-row>

          <CounterOne />
        </v-container>
      </div> -->
    <!-- End Counterup Area -->

    <!-- Start Blog Area  -->
    <BlogNotinOne class="home-section" />

    <!-- End Blog Area  -->
    <!-- Start Call to Action Area -->
    <template v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.CallToAction && NOTARIA.Theme.Home.CallToAction.Mostrar">
       <CallToActionNotinTwo class="home-section" v-if="NOTARIA.Theme.Home.CallToAction.Design === 2" />
       <CallToActionNotinOne class="home-section" v-else />
    </template>
    <!-- End Call to Action Area -->
    
    <!-- Start Testimonial Area  -->
    <TestimonialNotinOne class="home-section" />
    <!-- Start Testimonial Area  -->
    <GalleryNotinOne class="home-section" />

    <!-- Start FAQ Area -->
    <template v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.FAQ && NOTARIA.Theme.Home.FAQ.Mostrar">
      <FaqNotinOne class="home-section" />
    </template>
    <!-- End FAQ Area -->

    <!-- Start Contact Area  -->
    <template v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.Form.Mostrar">
      <!-- El diseño Guiado (Design === 2) se muestra cuando la notaría lo tiene configurado -->
      <ContactFormGuiado class="home-section" v-if="NOTARIA.Theme.Home.Form.Design === 2" :contactForm="style.ThemeHomeFormContact"/>
      <ContactFormPersonalizado class="home-section" v-else-if="NOTARIA.Theme.Home.Form.Design === 3" :contactForm="style.ThemeHomeFormContact"/>
      <ContactFormNotinTwo class="home-section" v-else-if="NOTARIA.Theme.Home.Form.Design === 1 || NOTARIA.Theme.Home.Form.Design === null || NOTARIA.Theme.Home.Form.Design === undefined" :contactForm="style.ThemeHomeFormContact"/>
      <ContactFormNotinOne class="home-section" v-else :contactForm="style.ThemeHomeFormContact"/>
    </template>
    <!-- End Contact Area  -->
  </div>
</template>

<script setup lang="ts">
import { toRaw, onMounted } from "vue";
import { useStore } from '../store/index.ts'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
import {useMetaTags} from '../composables/metaTags.ts'
import N2Inicio from '../components/notaria2/N2Inicio.vue'
import N3Inicio from '../components/notaria3/N3Inicio.vue'
import N4Inicio from '../components/notaria4/N4Inicio.vue'
import N5Inicio from '../components/notaria5/N5Inicio.vue'
// Plantillas 2 y 3: su propia portada con los mismos datos y secciones
// (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY)
const { plantilla } = usePlantilla()

const PageName="Home"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
import { useStyles } from '../store/styles';
const style = useStyles();

onMounted(() => {
  console.log("DISEÑO BANNER ACTUAL:", NOTARIA.value?.Theme?.Home?.Banner?.Design);
})


</script>

<style scoped lang="scss">
#home {
  .home-section:nth-of-type(odd) {
    background-color: #ffffff;
  }
  .home-section:nth-of-type(even) {
    background-color: #f5f8fa;
  }
}
</style>
